// React
import * as React from 'react';

// Router
import { Link } from 'react-router-dom';

// Redux
import { connect } from 'react-redux';

// MainStore
import { MainStore } from '../../stores/MainStore';

// Components
import Button from '@material-ui/core/Button';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import Icon from '@material-ui/core/Icon';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { NetworkManager, MethodRequest_e } from '../../managers/NetworkManager';

/**
 * @description Props Interface
 * @author Lucas Fridez <lucas@fridez.dev>
 * @interface Props
 */
interface Props {
    apiPath: any;
    loadData: any;
    navigation?: any;
    numSelected: number;
    readonly?: boolean;
    selectedIds: Array<any>;
    title: string;
    view?: boolean;
    urlPath?: string;
}

interface State {
    openMultipleDeleteModal: boolean;
    redirectToView: boolean;
}

/**
 * @author Lucas Fridez <lucas@fridez.dev>
 * @description Component EnhancedTableToolbar
 */
export default connect<{}, {}, Props>((state) => state)(class EnhancedTableToolbar extends React.Component<Props, State> {

    /**
     * Creates an instance of EnhancedTableToolbar.
     * @author Lucas Fridez <lucas@fridez.dev>
     * @param {*} props
     */
    constructor(props: any) {
        super(props);
        this.state = {
            openMultipleDeleteModal: false,
            redirectToView: false
        };
    }

    /**
     * @description Delete the selected items
     * @author Lucas Fridez <lucas@fridez.dev>
     * @returns
     */
    public onDeleteClick() {
        return async (e: React.MouseEvent<any>) => {
            this.setState({
                openMultipleDeleteModal: true
            });
        };
    }

    /**
     * @description Navigate to the edition of the selected item
     * @author Lucas Fridez <lucas@fridez.dev>
     * @returns
     */
    public onEditClick() {
        return (e: React.MouseEvent<any>) => {
            //console.log(this.props.selectedIds[0]);
        };
    }

    handleCloseMultipleDeleteModal = () => {
        this.setState({
            openMultipleDeleteModal: false
        });
    }

    handleDeleteMaterials = async() => {
        this.handleCloseMultipleDeleteModal();
        try {
            await NetworkManager.request(`${this.props.apiPath}/delete`, MethodRequest_e.DELETE, {
                ids: this.props.selectedIds
            }).then((response: any) => {
                MainStore.showNotification(response.text);
            });
            this.props.loadData();
        } catch (error) {
            MainStore.showNotification(error.text, "bg-col-error");
        } finally {
            MainStore.hideOverlay();
        }
    }

    /**
     * @description Render the AppBar Component
     * @author Lucas Fridez <lucas@fridez.dev>
     * @returns
     */
    render() {
        const { numSelected, readonly } = this.props;
        const { openMultipleDeleteModal } = this.state;

        return (
            <Toolbar style={{ justifyContent: "space-between" }} className={numSelected > 0 ? "toolbar-colored" : ""}>
                <div style={{ flex: '0 0 auto' }}>
                    {numSelected > 0 ?
                        (<Typography color="inherit" variant="subheading">{`${numSelected} sélectionné${numSelected > 1 ? "s" : ""}`}</Typography>)
                        :
                        (<Typography variant="title" id="tableTitle" style={{lineHeight: "64px"}}>{this.props.title}</Typography>)}
                </div>
                <div style={{lineHeight: "64px"}}>
                    {numSelected > 0 ? (
                        <IconButton aria-label="Delete" onClick={this.onDeleteClick()}>
                            <DeleteIcon />
                        </IconButton>
                    ) : (
                            <div>
                                {(!readonly && this.props.apiPath != "texta") &&
                                    <Link to={`${this.props.urlPath}/Créer`}
                                        onClick={MainStore.updateActualView(`${this.props.urlPath}/Créer`)}>
                                        <Button variant="contained" className="button-add">
                                            <Icon>add</Icon> Créer
                                    </Button>
                                    </Link>}
                            </div>
                        )}
                </div>
                <Dialog
                    aria-labelledby="delete-modal"
                    aria-describedby="delete-modal"
                    disableAutoFocus={true}
                    open={openMultipleDeleteModal}
                    onClose={this.handleCloseMultipleDeleteModal}>
                    <DialogTitle>Suppression</DialogTitle>
                    <DialogContent>
                        <Typography variant="body1" gutterBottom={true}>
                            Êtes-vous sûr de vouloir supprimer tous les éléments sélectionnés ?</Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCloseMultipleDeleteModal}>Annuler</Button>
                        <Button color="secondary" onClick={this.handleDeleteMaterials}>Supprimer</Button>
                    </DialogActions>
                </Dialog>
            </Toolbar>
        );
    }
});



// WEBPACK FOOTER //
// ./src/app/components/DataTable/EnhancedTableToolbar.tsx